import { useMemo } from 'react';

import { useSubscriptions } from '@adsk/alloy-provider';

import { TRIAL, STATUSES } from '../components/SubscriptionItem/helpers/consts';
import { Offering } from '../helpers/types';

const useUserSubscriptions = () => {
  const {
    data: userSubscriptionsData,
    error,
    loading,
    retry,
  } = useSubscriptions();

  const sortedSubscriptions: Offering[] = useMemo(() => {
    const subscriptions: Offering[] = userSubscriptionsData || [];

    const activeSubscriptions = subscriptions.filter(
      (subscription) => subscription.status === STATUSES.ACTIVE,
    );

    // For each TRL element we check if it has duplicate

    activeSubscriptions?.forEach((subscription: Offering | null, index) => {
      if (subscription?.type === TRIAL) {
        //If we find a trial we check if it has other paid subscription
        activeSubscriptions.forEach((subscription2, index2) => {
          if (
            subscription?.offeringName === subscription2.offeringName &&
            subscription2.type !== TRIAL &&
            index !== index2
          ) {
            activeSubscriptions.push({
              ...subscription2,
              alternativeSubscription: {
                daysRemaining: subscription.daysRemaining,
                offeringName: subscription.offeringName,
                type: subscription.type,
              },
            });
            activeSubscriptions[index] = {
              ...activeSubscriptions[index],
              type: 'removable',
            };
            activeSubscriptions[index2] = {
              ...activeSubscriptions[index2],
              type: 'removable',
            };

            return;
          }
          return;
        });
      }
      return;
    });

    return activeSubscriptions
      .filter((value) => value.type !== 'removable')
      .sort((a: Offering, b: Offering) => {
        if (!b.daysRemaining) return 1;
        if (!a.daysRemaining) return -1;

        return b.daysRemaining - a.daysRemaining;
      });
  }, [userSubscriptionsData]);

  return {
    subscriptions: sortedSubscriptions,
    error: !!error,
    isLoading: loading,
    refetch: retry,
  };
};

export default useUserSubscriptions;
